import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import { format } from 'date-fns';

const DailyLogTable = ({ activities, selectedDate }) => {
  const dateStr = format(selectedDate, 'yyyy-MM-dd');

  // Group logs by activity + employee
  const groupedLogs = {};

  activities.forEach((activity) => {
    const logs = activity.dailyLog || [];

    logs.forEach((log) => {
      const logDate = format(new Date(log.date), 'yyyy-MM-dd');

      if (logDate !== dateStr) return;

      const key = `${activity.name}__${log.by?._id || log.by}`;

      if (!groupedLogs[key]) {
        groupedLogs[key] = {
          activityName: activity.name,
          employeeName: log.by?.name || 'Unknown',
          quantity: 0,
          target: activity.dailyTarget || 0,
        };
      }

      groupedLogs[key].quantity += log.quantity;
    });
  });

  const rows = Object.values(groupedLogs);

  if (rows.length === 0) {
    return <p className="text-gray-400 italic text-center py-8">No logs found for {dateStr}.</p>;
  }

  return (
    <div className="overflow-x-auto border rounded-2xl bg-white shadow-lg mt-4 p-4 border-gray-100">
      <table className="min-w-full text-sm text-left">
        <thead className="bg-blue-100 text-[#173861]">
          <tr>
            <th className="px-4 py-3 font-semibold">Activity</th>
            <th className="px-4 py-3 font-semibold">Employee</th>
            <th className="px-4 py-3 font-semibold">Total Qty</th>
            <th className="px-4 py-3 font-semibold">Target</th>
            <th className="px-4 py-3 font-semibold">Status</th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {rows.map((log, i) => {
            const met = log.quantity >= log.target;
            return (
              <tr key={i} className="hover:bg-gray-50 transition">
                <td className="px-4 py-2">{log.activityName}</td>
                <td className="px-4 py-2">{log.employeeName}</td>
                <td className="px-4 py-2">{log.quantity}</td>
                <td className="px-4 py-2">{log.target}</td>
                <td className="px-4 py-2">
                  <span
                    className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold shadow-sm border transition-all duration-150 ${
                      met ? 'bg-green-100 text-green-800 border-green-200' : 'bg-red-100 text-red-800 border-red-200'
                    }`}
                  >
                    {met ? <CheckCircle size={14} /> : <XCircle size={14} />}
                    {met ? 'Met' : 'Missed'}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DailyLogTable;